import React, { useState, useEffect } from 'react';
import axios from 'axios';

const QRDisplay = () => {
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [qrHistory, setQrHistory] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  // Fetch current QR code
  const fetchCurrentQR = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API_BASE_URL}/qr`);
      setQrData(response.data);
    } catch (err) {
      setError(err.response?.data || 'Failed to fetch QR code');
      setQrData(null);
    } finally {
      setLoading(false);
    }
  };

  // Fetch QR history from database
  const fetchQRHistory = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/qr-codes`);
      setQrHistory(response.data);
    } catch (err) {
      console.error('Failed to fetch QR history:', err);
    }
  };

  // Fetch latest active QR from database
  const fetchLatestQR = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/qr-codes/latest`);
      setQrData({ qr: response.data.qr_image });
    } catch (err) {
      setError(err.response?.data?.message || 'No active QR code found');
      setQrData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrentQR();
    fetchQRHistory();
    
    // Auto refresh every 10 seconds
    const interval = setInterval(() => {
      fetchCurrentQR();
      fetchQRHistory();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getStatusClass = (status) => {
    return `qr-status ${status}`;
  };

  return (
    <div>
      <div className="card">
        <h2 className="card-title">WhatsApp QR Code</h2>
        
        <div className="qr-container">
          {loading && <div className="loading">Loading QR code...</div>}
          
          {error && (
            <div className="error">
              {error}
              <br />
              <button className="btn" onClick={fetchLatestQR} style={{ marginTop: '1rem' }}>
                Try Latest from Database
              </button>
            </div>
          )}
          
          {qrData && qrData.qr && (
            <div>
              <img 
                src={qrData.qr} 
                alt="WhatsApp QR Code" 
                className="qr-image"
              />
              <p>Scan this QR code with your WhatsApp to connect</p>
            </div>
          )}
          
          <div style={{ marginTop: '2rem' }}>
            <button className="btn" onClick={fetchCurrentQR} disabled={loading}>
              Refresh QR Code
            </button>
            <button className="btn" onClick={fetchLatestQR} disabled={loading}>
              Get Latest QR
            </button>
          </div>
        </div>
      </div>

      {
      /*
      qrHistory.length > 0 && (
        <div className="card">
          <h3 className="card-title">QR Code History</h3>
          <div>
            {qrHistory.map((qr) => (
              <div key={qr.id} className="message-item">
                <div className="message-header">
                  <div>
                    <span className={getStatusClass(qr.status)}>
                      {qr.status.toUpperCase()}
                    </span>
                    <span style={{ marginLeft: '1rem', fontSize: '0.9rem', color: '#666' }}>
                      Session: {qr.session_name}
                    </span>
                  </div>
                  <div className="message-meta">
                    <span>Created: {formatDate(qr.created_at)}</span>
                    {qr.expires_at && (
                      <span>Expires: {formatDate(qr.expires_at)}</span>
                    )}
                  </div>
                </div>
                
                {qr.qr_image && (
                  <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                    <img 
                      src={qr.qr_image} 
                      alt={`QR Code ${qr.id}`}
                      style={{ maxWidth: '200px', width: '100%', height: 'auto' }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )
        */
        }
    </div>
  );
};


export default QRDisplay;